var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.661 9.64557C13.1373 9.54883 12.6563 9.88303 12.5566 10.3942C12.4569 10.9054 12.7922 11.4045 13.3016 11.5046C14.8355 11.8036 16.0198 12.9909 16.32 14.53V14.5311C16.4054 14.9741 16.7955 15.2962 17.2447 15.2962C17.3049 15.2962 17.3652 15.2907 17.4265 15.2797C17.936 15.1775 18.2712 14.6795 18.1715 14.1672C17.7234 11.8685 15.9541 10.093 13.661 9.64557Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5958 5.81341C13.3504 5.77823 13.1039 5.85079 12.9078 6.0069C12.7062 6.1652 12.5802 6.39387 12.5528 6.65002C12.4948 7.16781 12.8684 7.63613 13.3855 7.6944C16.9516 8.09236 19.7235 10.8704 20.1245 14.4477C20.1782 14.927 20.5803 15.2887 21.0601 15.2887C21.0963 15.2887 21.1313 15.2865 21.1675 15.2821C21.4184 15.2546 21.6419 15.1304 21.7996 14.9325C21.9563 14.7346 22.0275 14.4884 21.999 14.2366C21.4995 9.77327 18.045 6.30922 13.5958 5.81341Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93585 10.9707C14.3243 15.3578 15.3198 10.2824 18.1139 13.0745C20.8077 15.7675 22.3559 16.3071 18.943 19.7191C18.5154 20.0626 15.7993 24.196 6.25365 14.653C-3.29314 5.10888 0.837822 2.38991 1.18148 1.96253C4.60269 -1.45891 5.13293 0.0983305 7.82668 2.79133C10.6208 5.58467 5.54745 6.58348 9.93585 10.9707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvg);
export default __webpack_public_path__ + "static/media/phoneSvg.f25d4e4fd9df5b49bd97c336e71e7881.svg";
export { ForwardRef as ReactComponent };